export const ProgramData = [
  {
    id: 108,
    title: "OFF-CAMPUS PLACEMENT COHORT",
    image: "placementCohort.jpg",
    description:
      "Join our result-driven placement cohort and unlock the path to landing high-impact roles at top companies and firms. Whether you're targeting finance, consulting, marketing, or other roles, this cohort equips you with essential tools, insights, and mentorship to stand out in a competitive job market.",
    features: [
      "Resume Revamp for Corporate Roles",
      "Personalized LinkedIn Optimization",
      "Case Studies & Technical Interview Prep",
      "Mock HR + Technical Interviews",
      "Job Search Strategy & Outreach Templates",
    ],
    duration: "8 weeks",
    startDate: "September 1st, 2025",
    price: 15000,
    discountedPrice: 9999,
    tags: [
      {
        name: "High Conversion Support",
        color: "bg-yellow-400 text-gray-900",
      },
      {
        name: "Expert Mentor",
        color: "bg-[#a78bfa] text-gray-900",
      },
    ],
    cta: "Apply Now",
    link: "/placement-cohort",
    stats: [
      { value: "500+", label: "Students Enrolled" },
      { value: "4.9", label: "Average Rating" },
      { value: "8+", label: "Hours of Content" },
    ],
  },
  // {
  //   id: 106,
  //   title: "HR Fellowship",
  //   image: "HRFellowshipAug.jpg",
  //   description:
  //     "Join our 4-week live cohort and learn how to break into HR & Talent Acquisition roles—without relying on vague LinkedIn advice. We’ll walk you through resume building, outreach, interviews, and a real recruiter simulation—step by step.",
  //   features: [
  //     "HR Resume + LinkedIn that actually converts",
  //     "Understanding HR roles: TA, HRBP, L&D & more",
  //     "Naukri, cold mails & recruiter simulation",
  //   ],
  //   duration: "4 weeks",
  //   startDate: "August 1, 2025",
  //   price: 1500,
  //   discountedPrice: 999,
  //   tags: [
  //     {
  //       name: " High Conversion Strategy",
  //       color: "bg-yellow-400 text-gray-900",
  //     },
  //     {
  //       name: "HR Mentor from a Top Company",
  //       color: "bg-[#a78bfa] text-gray-900",
  //     },
  //   ],
  //   cta: "Apply Now",
  //   link: "/hr-fellowship",
  //   stats: [
  //     { value: "500+", label: "Students Enrolled" },
  //     { value: "4.9", label: "Average Rating" },
  //     { value: "8+", label: "Hours of Content" },
  //   ],
  // },
  {
    id: 104,
    title: "OFF-CAMPUS INTERNSHIP COHORT",
    image: "offcampuscohort.jpg",
    description:
      "Join our exclusive internship cohort and learn how to secure valuable off-campus internships at top companies. Our program is designed to equip you with the skills, strategies, and network needed to stand out in competitive application processes.",
    features: [
      "Resume building workshops",
      "Interview preparation",
      "Networking opportunities",
      "Personalized feedback",
    ],
    duration: "8 weeks",
    startDate: "June 15, 2025",
    price: 1500,
    discountedPrice: 199,
    tags: [
      {
        name: "High Placement Rate",
        color: "bg-yellow-400 text-gray-900",
      },
      {
        name: "Industry Mentors",
        color: "bg-[#a78bfa] text-gray-900",
      },
    ],
    cta: "Apply Now",
    link: "/internship-cohort",
    stats: [
      { value: "500+", label: "Students Enrolled" },
      { value: "4.9", label: "Average Rating" },
      { value: "8+", label: "Hours of Content" },
    ],
  },
  // {
  //   id: 103,
  //   title: "MARKETING FELLOWSHIP",
  //   subtitle: "NOT THEORY. JUST REAL MARKETING.",
  //   image: "marketingpic.jpg",
  //   description:
  //     "Join our Marketing Fellowship and gain real-world experience by working on live campaigns. Learn practical strategies from industry experts behind top brand successes—no fluff, just results-driven learning",
  //   features: [
  //     "Hands on IMC Project",
  //     "Pitchdeck and Portfolio",
  //     "Content strategy development",
  //   ],
  //   duration: "12 weeks",
  //   startDate: "July 1, 2025",
  //   price: 1000,
  //   discountedPrice: 299,
  //   tags: [
  //     {
  //       name: "Practical Learning",
  //       color: "bg-green-400 text-gray-900",
  //     },
  //     {
  //       name: "Industry Projects",
  //       color: "bg-[#a78bfa] text-gray-900",
  //     },
  //   ],
  //   cta: "Join Fellowship",
  //   link: "/marketing",
  //   stats: [
  //     { value: "300+", label: "Students Enrolled" },
  //     { value: "4.7", label: "Average Rating" },
  //     { value: "12+", label: "Hours of Content" },
  //   ],
  // },
  // {
  //   id: 105,
  //   title: "SDE Intern Fellowship",
  //   image: "SDECohortPicture.jpg",
  //   description:
  //     "Join our 4-week live cohort and learn how to crack high-quality SDE internships—without solving 500 questions blindly. We’ll walk you through DSA strategy, resume building, outreach, and interviews—step by step.",
  //   features: [
  //     "DSA & CS fundamentals roadmap",
  //     "Resume + GitHub + LinkedIn setup",
  //     "Cold mails, referrals, and interview prep",
  //   ],
  //   duration: "4 weeks",
  //   startDate: "June 21, 2025",
  //   price: 1999,
  //   discountedPrice: 999,
  //   tags: [
  //     {
  //       name: "High Conversion Strategy",
  //       color: "bg-yellow-400 text-gray-900",
  //     },
  //     {
  //       name: "Tech Mentor from a Top Company",
  //       color: "bg-[#a78bfa] text-gray-900",
  //     },
  //   ],
  //   cta: "Apply Now",
  //   link: "/sde-fellowship",
  //   stats: [
  //     { value: "500+", label: "Students Enrolled" },
  //     { value: "4.9", label: "Average Rating" },
  //     { value: "8+", label: "Hours of Content" },
  //   ],
  // },
];
